import { all } from 'redux-saga/effects'

import { addFavoriteVenueSagaWatcher } from './add_favorite_venue.saga'
import { changeUserEmailSagaWatcher } from './change_user_email.saga'
import { deleteUserSagaWatcher } from './delete_user.saga'
import { getUserSagaWatcher } from './get_user.saga'
import { getUsersSagaWatcher } from './get_users.saga'
import { removeFavoriteVenueSagaWatcher } from './remove_favorite_venue.saga'
import { setSelectedUserSagaWatcher } from './set_selected_user.saga'
import { setValidPhoneSagaWatcher } from './set_valid_phone.saga'
import { updateUserSagaWatcher } from './update_user.saga'

export default function * userSaga () {
  yield all([
    addFavoriteVenueSagaWatcher(),
    getUserSagaWatcher(),
    getUsersSagaWatcher(),
    deleteUserSagaWatcher(),
    updateUserSagaWatcher(),
    removeFavoriteVenueSagaWatcher(),
    setSelectedUserSagaWatcher(),
    changeUserEmailSagaWatcher(),
    setValidPhoneSagaWatcher()
  ])
}
